export default "__VITE_ASSET__CIL$arF4__"